var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPreloader)?_c('div',{staticClass:"configurator-skeleton"},[_c('div',{staticClass:"configurator-skeleton__fields"},_vm._l(([1, 2, 3, 4, 5, 6, 7]),function(item){return _c('a-skeleton',{key:item,attrs:{"active":"","avatar":{
          shape: 'circle'
        },"paragraph":{
          rows: 1
        }}})}),1),_vm._v(" "),_c('div',{staticClass:"configurator-skeleton__summ"},[_c('a-skeleton',{attrs:{"active":"","paragraph":{
          rows: 2
        }}}),_vm._v(" "),_c('a-skeleton',{attrs:{"active":"","paragraph":{
          rows: 2
        }}})],1)]):_vm._e(),_vm._v(" "),_c('iframe',{style:({opacity: _vm.isPreloader ? 0 : 1, height: _vm.isPreloader ? 0 : (_vm.height + "px")}),attrs:{"src":"/custom_calc/?new-design","width":"100%","frameborder":"no","seamless":"","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }